export const AMOUNT_KEY = 'controlValues.amount';
export const UNIT_KEY = 'controlValues.unit';
export const CRON_KEY = 'controlValues.cron';
export const TYPE_KEY = 'controlValues.type';
export const LOOKBACK_AMOUNT_KEY = 'controlValues.lookBackWindow.amount';
export const LOOKBACK_UNIT_KEY = 'controlValues.lookBackWindow.unit';
